import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useFetch } from '../useFetch'
import { useAuth } from '../../contexts/AuthContext'

import { CONFIG } from '../../config'
import { ClubModel } from '../../types/court/court'
import { ApiError } from '../../types/exception/errorStatus'
import { getErrorMessage } from '../../utils/exception/exceptionUtils'

export function useCreateClub() {
  const { t } = useTranslation(['clubs', 'exceptions'])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [success, setSuccess] = useState<string | null>(null)
  const { authInfo } = useAuth()
  const { poster } = useFetch(authInfo?.accessToken, authInfo?.refreshToken)

  const resetState = () => {
    setLoading(false)
    setError(null)
    setSuccess(null)
  }

  const createClub = async (club: ClubModel) => {
    setLoading(true)
    try {
      const data = await poster<ClubModel>(
        `${CONFIG.BOUNCE_API}/api/v1/clubs`,
        club,
        'application/json'
      )
      if (data) {
        setSuccess(t('clubs:clubs.successfully-created'))
        setError(null)
        return data
      }
    } catch (caughtError) {
      console.log(caughtError)
      if (caughtError instanceof ApiError) {
        setError(getErrorMessage(caughtError.data))
      } else {
        setError(t('exceptions:unknown'))
      }
    } finally {
      setLoading(false)
    }
  }

  return { createClub, loading, error, success, resetState }
}
